<template>
  <div class="employee-information">
    <div class="select-container">
      <div class="select-container-box">
        <span>查找&nbsp;&nbsp;</span>
        <el-input
          placeholder="请输入关键字"
          v-model="changeName"
          size="small"
          class="search-input"
          type="text"
          :maxlength="num"
          onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
          clearable>
        </el-input>
      </div>
      <div class="select-container-box" >
        <el-button size="small"  type="info" plain @click="init()" class="query">查询</el-button>
         <el-button size="small"  type="info" plain @click="add()" class="add" v-if="$store.state.curCompany.isQlwVersion==true&&edit">增加</el-button> 
        <el-button size="small"  type="info" plain @click="add()" class="add" v-if="$store.state.curCompany.isQlwVersion==false&&edit">增加</el-button> 
      </div>
    </div>
    <!-- 表单内容 -->
    <div class="table-container">
      <el-table
        :data="roleSetting.list"
        @row-dblclick="dataBackFillGoods"
        style="width:100%;"
        size="medium"
        :default-sort = "{prop: 'date', order: 'descending'}">
        <i slot="empty" style="font-style:normal">暂无数据</i>
        <el-table-column
          prop="roleName"
          label="角色名"
          align="center"
          show-overflow-tooltip
          >
        </el-table-column>
        <el-table-column
          prop="roleNum"
          label="角色人数"
          align="center"
          >
        </el-table-column>
        <el-table-column
          prop="description"
          align="center"   
          show-overflow-tooltip            
          label="角色描述">
        </el-table-column>
        <el-table-column
          prop="entryDate"
          label="开启"
          align="center"
          >
          <template slot-scope="scope">
            <el-switch
              v-if="scope.row.roleId!=-1&&$store.state.curCompany.isQlwVersion==true&&edit"
              :value="scope.row.isOpen"
              @change="changeSwitch(scope.$index, scope.row)"
              >
            </el-switch>
            <el-switch
              v-if="scope.row.roleId!=-1&&$store.state.curCompany.isQlwVersion==false"
              :value="scope.row.isOpen"
              :disabled="!edit"
              @change="changeSwitch(scope.$index, scope.row)"
              >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="170">
          <template slot-scope="scope">
            <template v-if="scope.row.roleId!=-1">
               <span
              @click="handleEdit(scope.$index, scope.row)"  class="content-edit" v-if="$store.state.curCompany.isQlwVersion==true&&edit">修改权限</span>
              <span
                @click="handleDelete(scope.$index, scope.row)"  class="content-del" v-if="$store.state.curCompany.isQlwVersion==true&&edit">删除</span>
              <span
              @click="handleEdit(scope.$index, scope.row)"  class="content-edit" v-if="$store.state.curCompany.isQlwVersion==false">{{edit?"修改权限":"查看权限"}}</span>
              <span
                @click="handleDelete(scope.$index, scope.row)"  class="content-del" v-if="$store.state.curCompany.isQlwVersion==false&&edit">删除</span>
            </template>
            <!-- 当roleId为-1时为系统管理员 -->
            <template v-if="scope.row.roleId==-1">
              <span class="content-edit">系统设置不能修改</span>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <page-change :pageInfo="pageInfo"></page-change>
    <base-dialog :settingDialog="settingDialog" :showDialog.sync="showDialog" @closeDialog="closeDialog">
      <base-form :forms="forms" :rules="rules" ref="form" >
        <el-form-item prop="roleName" label="角色名称" >
          <el-input v-model="forms.roleName"  placeholder="请输入角色名称" v-if="$store.state.curCompany.isQlwVersion==true" :maxlength="num" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
          >
          </el-input>
          <el-input v-model="forms.roleName"  placeholder="请输入角色名称" v-if="$store.state.curCompany.isQlwVersion==false" :disabled="!edit"  :maxlength="num" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="description" label="角色描述" >
          <el-input v-model="forms.description"  placeholder="请输入角色描述" v-if="$store.state.curCompany.isQlwVersion==true" :maxlength="num" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
          >
          </el-input>
          <el-input v-model="forms.description"  placeholder="请输入角色描述" v-if="$store.state.curCompany.isQlwVersion==false" :disabled="!edit" :maxlength="num" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="permission" class="permission" label="权限分配" >
          <div class="tree-wrap">
            <h4>
              <img src="../../../../../public/img/icon_prompt.png" alt="">
              <span>浏览权限支持查看，不能添加和编辑；编辑权限代表可进行修改和添加</span>
            </h4>
            <el-checkbox class="all-choose" v-model="isAll" @change="allItem($event,fromData)" v-if="$store.state.curCompany.isQlwVersion==true&&edit">全选</el-checkbox>
            <my-tree :fromData="fromData" :toData="toData" class="tree" @judgeSelect="judgeSelect" v-if="$store.state.curCompany.isQlwVersion==true"></my-tree>
            <el-checkbox class="all-choose" v-model="isAll" @change="allItem($event,fromData)" v-if="$store.state.curCompany.isQlwVersion==false" :disabled="!edit">全选</el-checkbox>
            <my-tree :fromData="fromData" :toData="toData" :edit="edit" class="tree" @judgeSelect="judgeSelect" v-if="$store.state.curCompany.isQlwVersion==false" :disabled="!edit"></my-tree>
          </div>
        </el-form-item>
        <div class="dialog-footer" v-if="$store.state.curCompany.isQlwVersion==true&&edit">
          <el-button @click="cancel('form')">取 消</el-button>
          <el-button type="primary" @click="save('form',fromData)" >保 存</el-button>
        </div>
        <div class="dialog-footer" v-if="$store.state.curCompany.isQlwVersion==false&&edit">
          <el-button @click="cancel('form')">取 消</el-button>
          <el-button type="primary" @click="save('form',fromData)" >保 存</el-button>
        </div>
      </base-form>
    </base-dialog>
    
  </div>
</template>

<script>
import Url from "../../../../service/base-url.js";
import { mapActions, mapState } from "vuex";
import { modules } from "../../../../store";
import PageChange from "../../../common/PageChange";
import MyTree from "./TreeMenu";
import BaseDialog from "./BaseDialog";
import BaseForm from "./BaseForm";
import checkPermission from "../../../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
export default {
  name: "RoleSetting",
  mixins: [mixins],
  components: {
    PageChange,
    BaseDialog,
    BaseForm,
    MyTree
  },
  data() {
    return {
      defaultProps: {
        children: "menus",
        label: "permissionName"
      },
      isAll: "",
      fromData: [],
      toData: [],
      temp: [],
      num: 50,
      forms: {
        roleId: "",
        roleName: "",
        roleNum: "",
        description: "",
        isOpen: "",
        permission: ""
      },
      rules: {
        roleName: [
          {
            required: true,
            message: "请输入角色名称",
            trigger: "blur"
          }
        ],
        permission: [
          {
            // required: true
          }
        ]
      },
      settingDialog: {
        visible: true,
        titleName: "增加角色",
        dialogWidth: "760px",
        activeClass: "roleSet"
      },
      showDialog: false,
      changeName: "", // 搜索框字
      roleSetting: {
        list: [
          {
            roleId: "",
            roleName: "",
            roleNum: "",
            description: "",
            isOpen: ""
          }
        ],
        total: 0
      },
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.init, // 当前页数需要调用的函数
        pageSize: 10 // 当前页数
      }
    };
  },
  watch: {
    fromData: {
      handler(val) {
        console.log(1111);
      }
    }
  },
  async mounted() {
    console.log(mixins, this.curCompany, 111);
    this.init();
    this.fromData = this.changeData(await this.getAllPermission());
  },
  methods: {
    //接口
    ...mapActions(modules.roleSetting, [
      "getRoleSetting", //获取员工分页
      "deleteRoleSetting",
      "addRoleSetting",
      "getRoleSettingView",
      "editRoleSetting",
      "switchOnOff",
      "getAllPermission", //获取所有权限列表
      "getRoleById" // 根据id 获取已设置的权限
    ]),

    allItem(isAll, arr) {
      arr.forEach(item => {
        item.isCheck = isAll;
        if (item.menus) {
          this.allItem(isAll, item.menus);
        }
      });
    },
    // 初始化列表
    async init() {
      this.roleSetting = await this.getRoleSetting({
        PageIndex: this.pageInfo.pageNumber,
        PageSize: this.pageInfo.pageSize,
        QueryString: this.changeName,
        Version: 1
      });
      this.pageInfo.totalPages = this.roleSetting.total;
    },
    //时间格式化
    dataFormatter(row, column) {
      var date = row.entryDate;
      if (date == undefined) {
        return "";
      }
      return this.$timeformatDay(row.entryDate);
    },
    changeData(data) {
      return data.map(item => {
        item.isCheck = false;
        item.isReadOnly = false;
        if (item.menus) {
          this.changeData(item.menus);
        }
        return item;
      });
    },

    changeSwitch(index, row) {
      this.switchOnOff(row.roleId)
        .then(() => {
          this.init();
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: "获取数据失败!"
          });
        });
    },
    // 判断全选与非全选
    judgeSelect(val) {
      this.isAll = val;
    },
    // 判断是否全选
    judgeSelectAll() {
      let findObj = this.fromData.every(obj => {
        return obj.isCheck == true;
      });
      if (findObj) {
        this.isAll = true;
      }
    },

    async add() {
      this.forms = {
        roleId: "",
        roleName: "",
        roleNum: "",
        description: "",
        isOpen: ""
      };
      this.settingDialog.titleName = "添加角色信息";
      await this.permissionView({ rolePermissions: [] });
      this.showDialog = true;
    },
    judgeCheckIf(arr, list) {
      let isCheck = arr.find(item => {
        if (item.isCheck == true) {
          return true;
        } else {
          if (item.menus) {
            this.judgeCheckIf(item.menus, list);
          }
        }
      });
      if (isCheck) {
        list.push(isCheck);
      }
    },
    // 递归遍历  筛选已勾选的选项进行上传  [{permissionId: item.permissionId,isReadOnly: item.isReadOnly}]
    pList(list, arr) {
      list.forEach(item => {
        if (item.isCheck == true) {
          arr.push({
            permissionId: item.permissionId,
            isReadOnly: item.isReadOnly
          });
        }
        if (item.menus && item.menus.length != 0) {
          this.pList(item.menus, arr);
        }
      });
    },
    save(formName, array) {
      this.$refs[formName].$refs[formName].validate(valid => {
        if (valid) {
          let arr = [];
          let obj = {
            id: this.forms.roleId,
            name: this.forms.roleName,
            description: this.forms.description,
            versionType: 1,
            rolePermissions: arr
          };

          // 传入原始数组和 需要保存的数组 arr  刷选出已勾选的选项
          this.pList(array, arr);
          if (this.forms.roleId) {
            //  判断是否有选择权限
            let list = [];
            this.judgeCheckIf(this.fromData, list);
            if (list.length == 0) {
              this.$message({
                message: "未勾选权限",
                type: "error"
              });
              return;
            }
            //修改
            this.editRoleSetting(obj)
              .then(() => {
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                this.init();
                this.showDialog = false;
                this.$router.go(0);
              })
              .catch(error => {
                this.$message.error(error.response.data);
              });
          } else {
            //  判断是否有选择权限
            let list = [];
            this.judgeCheckIf(this.fromData, list);
            if (list.length == 0) {
              this.$message({
                message: "未勾选权限",
                type: "error"
              });
              return;
            }
            //  添加
            this.addRoleSetting(obj)
              .then(() => {
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                this.init();
                this.showDialog = false;
              })
              .catch(err => {
                this.$message.error(err.response.data);
              });
          }
        }
      });
    },
    //递归循环 设置树形图的勾选与否
    recursive(element, arr) {
      arr.forEach((item, i) => {
        if (item.permissionId == element.permissionId) {
          item.isCheck = true;
          item.isReadOnly = element.isReadOnly;
        }
        if (item.menus) {
          this.recursive(element, item.menus);
        }
      });
    },
    // 获取权限
    async permissionView(array) {
      this.toData = [];
      this.fromData = this.changeData(await this.getAllPermission());
      if (array.rolePermissions.length != 0) {
        array.rolePermissions.forEach(element => {
          this.recursive(element, this.fromData);
        });
      }
      this.fromData = this.fromData;
      this.judgeSelectAll();
      this.showDialog = true;
    },
    //双击进入编辑页面
    dataBackFillGoods(row, event) {
      this.getRoleById(row.roleId).then(data => {
        this.permissionView(data);
      });
      this.forms.roleId = row.roleId;

      if (this.$store.state.curCompany.isQlwVersion == true) {
        this.settingDialog.titleName = "修改权限信息";
      } else if (
        this.$store.state.curCompany.isQlwVersion == false &&
        this.edit == true
      ) {
        this.settingDialog.titleName = "修改权限信息";
      } else if (
        this.$store.state.curCompany.isQlwVersion == false &&
        this.edit == false
      ) {
        this.settingDialog.titleName = "查看权限信息";
      }

      // 获取编辑视图
      this.getRoleSettingView(row.roleId)
        .then(data => {
          this.forms.roleId = row.roleId;
          this.forms.roleName = data.name;
          this.forms.description = data.description;
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: "获取数据失败!"
          });
        });
    },
    // 点击编辑
    handleEdit(index, row) {
      this.getRoleById(row.roleId).then(data => {
        this.permissionView(data);
      });
      this.forms.roleId = row.roleId;
      if (this.$store.state.curCompany.isQlwVersion == true) {
        this.settingDialog.titleName = "修改权限信息";
      } else if (
        this.$store.state.curCompany.isQlwVersion == false &&
        this.edit == true
      ) {
        this.settingDialog.titleName = "修改权限信息";
      } else if (
        this.$store.state.curCompany.isQlwVersion == false &&
        this.edit == false
      ) {
        this.settingDialog.titleName = "查看权限信息";
      }

      // 获取编辑视图
      this.getRoleSettingView(row.roleId)
        .then(data => {
          this.forms.roleId = row.roleId;
          this.forms.roleName = data.name;
          this.forms.description = data.description;
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: "获取数据失败!"
          });
        });
    },
    // 删除
    handleDelete(index, row) {
      let pageIndex = this.pageInfo.pageNumber;
      if (this.pageInfo.totalPages % 10 === 1) {
        pageIndex -= 1;
      }
      this.$confirm("是否删除此记录", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          await this.deleteRoleSetting(row.roleId);
          this.init(pageIndex);
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(err => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error"
          });
        });
    },
    // 取消按钮
    cancel(formName) {
      this.closeDialog();
    },
    // 关闭弹窗
    closeDialog() {
      this.showDialog = false;
      this.$refs["form"].$refs["form"].resetFields();
    }
  }
};
</script>
<style lang="stylus">
.roleSet{
  display flex;
  align-items :center;
  .permission .el-form-item__label:before {
    left: -15px !important;
    font-size: 18px !important;
    color: #fe3223 !important;
  }
  .all-choose{
    position:absolute;
    right: 25px;
    margin-top: 5px;
    .el-checkbox__label{
      color:#333;
      font-size:14px;
      font-family:MicrosoftYaHeiUI;
      font-weight:400;
    }
    .el-checkbox__inner{

      border: 1px solid #dcdfe6;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner{
      background-color: #05c958;
      border-color: #03bf53;
    }
  }
  .el-dialog{
    margin-top:0 !important;
  }
  .tree-wrap{
    box-sizing: border-box;
    margin-left:-9px;
    h4{
      display:flex;
      align-items:center;
      width:500px;
      height:41px;
      background:rgba(247,247,247,1);
      border:1px solid rgba(224, 224, 224, 1);
      border-bottom:none;
      padding-left:20px;
      border-radius:4px 4px 0px 0px;
      box-sizing: border-box;
      img{
        margin-right:6px;
      }
    }
  }
  .tree{
    width:500px;
    height:348px;
    margin-left:0px;
    padding:20px 0 30px 20px;
    border:1px solid #e0e0e0;
    border-radius:0 0 6px 6px;
    box-sizing: border-box;
    overflow:auto;  
  }
  .base-form .el-form-item__content,.base-form .el-input__inner{
    width:500px !important;
  }
}
.employee-information
  .PageChange{
    justify-content: flex-end;
    margin-right:20px;
  }
  .content-container .titieMian .select-container{
    height:86px;
  }
  .table-container{
    border:none;
    padding:0px 20px 20px 20px;
  }
  .el-form-item__content{
    width:600px !important;
  }

</style>
